import { render, staticRenderFns } from "./ShopAssignmentFamilyPlus.vue?vue&type=template&id=0e72ffd0&scoped=true&"
import script from "./ShopAssignmentFamilyPlus.vue?vue&type=script&lang=js&"
export * from "./ShopAssignmentFamilyPlus.vue?vue&type=script&lang=js&"
import style0 from "./ShopAssignmentFamilyPlus.vue?vue&type=style&index=0&id=0e72ffd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72ffd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
